import { WithClassName } from '@/blocks/components/types';
import styles from './SocialLink.module.scss';
import classNames from 'classnames';
import typography from '@/styles/typography.module.scss';
import React, { ReactNode } from 'react';

type Props = {
  icon: React.ReactNode;
  linkTitle: ReactNode;
  link: string;
} & WithClassName;

export const SocialLink = ({ icon, linkTitle, link, className }: Props) => {
  return (
    <a
      className={classNames(styles.itemWrapper, className)}
      data-event-label={linkTitle}
      href={link}
      target={'blank'}
    >
      <div className={styles.iconWrapper}>{icon}</div>
      <p className={classNames(typography.bodyM, styles.linkTitle)}>{linkTitle}</p>
    </a>
  );
};
